module.exports = __webpack_public_path__ + "img/saude.416b6e54.svg";